import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-399f674f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "svg-inline",
  viewBox: "0 0 7 11",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M0 9.14775L3.825 5.32275L0 1.49775L1.18333 0.322754L6.18333 5.32275L1.18333 10.3228L0 9.14775Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "svg-inline",
  viewBox: "0 0 7 11",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M6.18359 1.49775L2.35859 5.32275L6.18359 9.14775L5.00026 10.3228L0.000260353 5.32275L5.00026 0.322754L6.18359 1.49775Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.right)
    ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
}